import React from "react";
import FEATURE_FLAGS from "@/utils/featureFlags";
import { CHROME_EXTENSION_URL } from "@/constants/constants";

const DeviceInstallLinksMarkdown = () => {
  const chromeExtensionEnabled = FEATURE_FLAGS.chromeExtensionEnabled;
  const useTestFlightIosApp = FEATURE_FLAGS.useTestFlightIosApp;
  const iosAppUrl = useTestFlightIosApp
    ? "https://testflight.apple.com/join/5qAPkjIl"
    : "https://apps.apple.com/us/app/pluto-attest/id6479618714";

  return (
    <ul className="list-disc ml-6 mt-6">
      <li>
        <a
          target="_blank"
          className="_underline _decoration-from-font _text-primary-600"
          href={iosAppUrl}
        >
          Install iOS App
        </a>
      </li>
      {chromeExtensionEnabled ? (
        <li>
          <a
            target="_blank"
            className="_underline _decoration-from-font _text-primary-600"
            href={CHROME_EXTENSION_URL}
          >
            Install Chrome Extension
          </a>
        </li>
      ) : (
        <li>
          Install Chrome Extension <span className="italic">(Coming soon)</span>
        </li>
      )}
    </ul>
  );
};

export default DeviceInstallLinksMarkdown;
